import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { DiOpenshift } from "react-icons/di";
import { IoTimeSharp } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import './layout.css';

const EmpLayout = ({ children }) => {
  const location = useLocation();
  
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <IoTimeSharp /> Employee Schedule
      </h1>
      <hr />
      <h1 className='layouts-subtitle'><FaUserAlt />Employee Name</h1>
      <div style={{ marginTop: '10px' }}>
        <section>
          <div className="nav-container">
            <ul className="nav-list">
              <li className="nav-item">
                <NavLink
                  id="/emps-timing/:userId-link"
                  className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/leave-report') ? 'active' : ''}`}
                  to="/emps-timing/:userId"
                >
                 <IoTimeSharp /> Timing
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  id="emp-shift-link"
                  className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/emps-leave-reports') ? 'active' : ''}`}
                  to="/emp-shift"
                >
                   <DiOpenshift /> Shift
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="content">
            {children}
          </div>
        </section>
      </div>
    </div>
  );
};

export default EmpLayout;
